import MarkupText from '@app/components/MarkupText'
import PillListRenderer from '@app/components/PillListRenderer'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import { formatDate } from '@app/utils/formatting'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  actionCreators,
  IAssignmentDetailState,
} from '../modules/assignmentDetail'

interface IConnectionViewRouterProps {
  id: string
}

type IComponentProps = IAssignmentDetailState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

class AssignmentDetails extends React.PureComponent<IComponentProps> {
  public render() {
    return (
      <div>
        <h5 className='section-title'>Assigned To</h5>
        <div className='ml-3'>
          {this.props.item.assignedTo ? (
            <PillListRenderer
              list={this.props.item.assignedTo}
              idValue='contactId'
            />
          ) : (
            'Not Assigned'
          )}
        </div>
        <h5 className='section-title'>Notes</h5>
        <div className='ml-3'>
          {this.props.item.markup ? (
            <MarkupText text={this.props.item.markup} />
          ) : (
            'No Notes'
          )}
        </div>
        <h5 className='section-title'>Reminders</h5>
        <div className='ml-3'>
          {this.props.item.reminders && this.props.item.reminders.size > 0
            ? this._renderReminders()
            : 'No Reminders'}
        </div>
      </div>
    )
  }

  private _renderReminders() {
    const reminders = this.props.item.reminders.map((item: any, index: any) => {
      return (
        <div key={`reminder-${index}`} className='d-flex flex-row flex-wrap'>
          <div>
            <strong>{`#${index + 1}`}</strong>
          </div>
          <div className='ml-2'>{`Remind me ${item.number} ${
            item.period
          } before ${formatDate(this.props.item.dueDate, 'MM/DD/YYYY')}`}</div>
        </div>
      )
    })

    return reminders
  }
}

export default withRouter(AssignmentDetails)
